import { FaChevronLeft, FaChevronRight, FaSearchPlus } from 'react-icons/fa';
import { IoLogoAndroid } from 'react-icons/io';
import { FaChevronDown } from 'react-icons/fa';
import { FaChevronUp } from 'react-icons/fa';
import { FaBars } from 'react-icons/fa';
import { FaRegPlusSquare } from 'react-icons/fa';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import { BiLoaderCircle } from 'react-icons/bi';
import { FaHandPointDown } from 'react-icons/fa';
import { FaSignInAlt } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { VscTriangleDown } from 'react-icons/vsc';
import { FiCalendar } from 'react-icons/fi';
import { FiArrowLeft } from 'react-icons/fi';
import { PiKeyFill } from 'react-icons/pi';
import { PiKeyDuotone } from 'react-icons/pi';
import { MdLiveTv } from 'react-icons/md';
import { FaDice } from 'react-icons/fa';

export const Icons = {
  Android: IoLogoAndroid,
  SearchPlus: FaSearchPlus,
  Down: FaChevronDown,
  Up: FaChevronUp,
  Menu: FaBars,
  PlusSquare: FaRegPlusSquare,
  MinusSquare: AiOutlineMinusSquare,
  Close: IoIosCloseCircleOutline,
  Tv: MdLiveTv,
  Cross: RxCross2,
  Eye: FaEye,
  EyeSlash: FaEyeSlash,
  Home: FaHome,
  Loading: BiLoaderCircle,
  PointDown: FaHandPointDown,
  SignIn: FaSignInAlt,
  Lock: FaLock,
  TriangleDown: VscTriangleDown,
  Calendar: FiCalendar,
  Back: FaChevronLeft,
  Forward: FaChevronRight,
  ArrowLeft: FiArrowLeft,
  Key: PiKeyFill,
  KeyOutline: PiKeyDuotone,
  Dice: FaDice,
};
